import PropTypes from 'prop-types';
import Immutable from 'immutable';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Markunread from '@mui/icons-material/Markunread';

import green from '@mui/material/colors/green';
import { TableRow, TableCell } from '@mui/material';
import ProfileDialog from '../boligsoegerlisten/profileDialog';

import shallowEqual from 'app/lib/shallow-equal';
import i18n from 'app/common/i18n';
import { dateToText } from '../../utils/helpers';

@i18n
class StatItem extends Component {
  static propTypes = {
    cellClassName: PropTypes.string,
    item: PropTypes.instanceOf(Immutable.Map).isRequired,
    admin: PropTypes.bool.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !(
      shallowEqual(this.props, nextProps) && shallowEqual(this.state, nextState)
    );
  }

  showAudit = () => {
    this.handleMenuClose();
    this.props.onAuditOpen(this.props.item['uuid']);
  };

  handleMenuOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { item, cellClassName, admin } = this.props;

    const {
      id,
      createdAt = null,
      updatedAt = null,
      seeker = {
        externalId: '',
        email: '',
        name: ''
      },
      latestMessage = {
        text: '',
        externalFrom: ''
      },
      dwelling = {
        uuid: '',
        status: '',
        active: false,
        address: 'Missing Address',
        zip: '',
        city: ''
      },
      unread
    } = item;

    const uuid = dwelling['uuid'];
    const latestText = String((latestMessage && latestMessage.text) || '');
    const latest =
      latestText.length > 20 ? latestText.substring(0, 20) + ' ...' : latestText;
    const address = (
      <span>
        {(dwelling.address || this.props.i18n('(no address)')).replace(
          /, [0-9]{4} [A-ZÆØÅ].*/,
          ''
        )}
        <br />
        {dwelling['zip'] ? `${dwelling.zip} ${dwelling.city}` : ''}
      </span>
    );

    const active = dwelling['active'];
    const status =
      latestMessage &&
      seeker &&
      latestMessage.externalFrom === seeker.externalId
        ? green[50]
        : '#ffff';
    const created = dateToText(createdAt);
    const updated = dateToText(updatedAt);

    return (
      <TableRow
        style={{
          background: status,
          opacity: active ? 1 : 0.5,
          textAlign: 'left'
        }}
      >
        <TableCell
          padding="none"
          className={cellClassName}
          style={{ whiteSpace: 'nowrap', textAlign: 'center' }}
          align="center"
        >
          {
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              {unread && !item.closed ? <Markunread /> : null}
              <Link to={`/messages/${id}`}>
                {item.closed
                  ? this.props.i18n('CLOSED')
                  : unread
                  ? this.props.i18n('NEW MESSAGE')
                  : this.props.i18n('OPEN')}
              </Link>
            </div>
          }
        </TableCell>
        <TableCell
          padding="none"
          className={cellClassName}
          style={{ whiteSpace: 'nowrap' }}
        >
          {uuid && active ? (
            <Link
              to={
                item.closed
                  ? `/dwellings/${uuid}/preview`
                  : `/dwellings/${uuid}`
              }
            >
              {address}
            </Link>
          ) : (
            address
          )}
        </TableCell>
        <TableCell
          padding="none"
          className={cellClassName}
          style={{ whiteSpace: 'nowrap', textAlign: 'center' }}
        >
          {admin ? (
            <ProfileDialog
              id={seeker.externalId}
              email={seeker.email}
              icon="person"
              label={seeker.name}
            />
          ) : (
            seeker.name
          )}
        </TableCell>
        <TableCell
          padding="none"
          className={cellClassName}
          style={{ whiteSpace: 'nowrap', textAlign: 'center' }}
        >
          {latest}
        </TableCell>
        <TableCell
          padding="none"
          className={cellClassName}
          style={{ whiteSpace: 'nowrap', textAlign: 'center' }}
        >
          {created}
        </TableCell>
        <TableCell
          padding="none"
          className={cellClassName}
          style={{ whiteSpace: 'nowrap', textAlign: 'center' }}
        >
          {updated}
        </TableCell>
      </TableRow>
    );
  }
}

export default StatItem;
